import * as React from 'react';
import ReactMarkdown from 'react-markdown';
import { observer } from 'mobx-react-lite';
import { Spin } from 'antd';
import { ContractComparisonModel } from '../../models';
import { useDebouncedLoading } from '../../hooks';
import { useAppStore } from '../../stores';
import './ContractComparisonSummaryRenderer.less';

interface Props {
    contractComparison: ContractComparisonModel;
    isVisible: boolean;
}

const ContractComparisonSummaryRenderer: React.FC<Props> = ({ contractComparison, isVisible }) => {
    const { contractComparisonStore } = useAppStore();

    const hasFreshSummary = contractComparison.hasFreshSummary;
    const hasResolvedSummaryForCurrentPayload = contractComparison.hasResolvedSummaryForCurrentPayload;
    const isLoading = useDebouncedLoading(
        (!hasResolvedSummaryForCurrentPayload && contractComparison.isAnyInputLoading) || contractComparison.isSummaryLoading
    );

    const className = `contract-comparison-summary-renderer${isVisible ? '' : ' hidden'}`;

    if (!contractComparisonStore.isComparisonSummaryConfigured) {
        return (
            <div className={`${className} empty`}>
                <span className="no-summary-available-text">Unable to generate summary - feature not configured</span>
            </div>
        );
    }

    if (isLoading) {
        return (
            <div className={`${className} loading`}>
                <Spin />
                <span className="loading-text">
                    {contractComparison.isSummaryLoading ? 'Generating summary...' : '\u00A0'}
                </span>
            </div>
        );
    }

    if (!hasFreshSummary || !contractComparison.generatedSummary) {
        return (
            <div className={`${className} empty`}>
                <span className="no-summary-available-text">No summary available</span>
            </div>
        );
    }

    return (
        <div className={className}>
            <ReactMarkdown>{contractComparison.generatedSummary}</ReactMarkdown>
        </div>
    );
};

export default observer(ContractComparisonSummaryRenderer);
